import { render, staticRenderFns } from "./SignList.vue?vue&type=template&id=3fb5473b&scoped=true"
import script from "./SignList.vue?vue&type=script&lang=js"
export * from "./SignList.vue?vue&type=script&lang=js"
import style0 from "./SignList.vue?vue&type=style&index=0&id=3fb5473b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5473b",
  null
  
)

export default component.exports